<template>
  <async-loader v-if="loading" />
  <div v-else-if="invoiceDetailsError" container class="_mtm">
    <p class="body-copy _text-center">{{ invoiceDetailsErrorMessage }}</p>
  </div>
  <div v-else>
    <page-title
      :open-amount="invoice.openAmount"
      :invoiceNumber="invoiceNumber"
    />
    <invoice-details :invoice="invoice" class="_bb1" />
    <related-files
      :invoice="invoice"
      v-for="(downloadCategoryKey, i) in Object.keys(downloadCategories)"
      :downloadCategory="downloadCategories[downloadCategoryKey]"
      :key="i"
      :index="i"
    />
  </div>
</template>

<script>
import PageTitle from './InvoiceDetails/PageTitle';
import InvoiceDetails from './InvoiceDetails/InvoiceDetails';
import RelatedFiles from './InvoiceDetails/RelatedFiles';
import fetchable from '@mixins/fetchable';
import billing from '@mixins/billing';
import { mapState } from 'vuex';
import { GET_SINGLE_INVOICE } from '@store/modules/billing/actionTypes';

export default {
  mixins: [fetchable, billing],
  components: {
    PageTitle,
    InvoiceDetails,
    RelatedFiles
  },
  computed: {
    invoiceNumber() {
      return this.$store.getters['hiddenRouteData/getHiddenRouteData']
        .invoiceNumber;
    },
    fetchers() {
      return [
        {
          action: GET_SINGLE_INVOICE,
          options: {
            invoiceNumber: this.invoiceNumber
          },
          portalContextDependent: false
        }
      ];
    },

    ...mapState({
      invoiceDetailsError: state => state.billing.invoiceDetailsError,
      invoiceDetailsErrorMessage: state =>
        state.billing.invoiceDetailsErrorMessage
    }),

    loading() {
      return this.$store.getters.invoicesLoading;
    },
    invoice() {
      return this.$store.getters.singleInvoice;
    },
    downloadCategories() {
      let categories = {};
      try {
        if (this.invoice.others) {
          this.invoice.others.map(otherItem => {
            if (!categories[otherItem.invoiceType]) {
              categories[otherItem.invoiceType] = {
                invoiceDescription: otherItem.invoiceDescription,
                files: []
              };
            }
            categories[otherItem.invoiceType].files.push(otherItem);
          });
        }
      } catch (error) {
        console.error(error);
      }
      return categories;
    }
  },
  beforeDestroy() {
    this.$store.state.billing.singleInvoiceLoading = true;
  }
};
</script>
